import { gql } from '@apollo/client';

export const getUserFacilities = gql`
  query getUserFacilities($email: String, $includeDirectReports: Boolean) {
    getUserFacilities(
      email: $email
      includeDirectReports: $includeDirectReports
    ) {
      id
      facilityName
      facilityUid
    }
  }
`;
